import { Pipe, PipeTransform, Input } from '@angular/core';
import { DateBaseTranslationsModel } from '@frontend/unhideschool/app/utils/i18n/locale/date-base/date-base.i18n.model';
import { LocaleServiceController } from '@frontend/unhideschool/app/utils/i18n/locale-service-controller.service';

@Pipe({
  name: 'dateAgo',
  pure: false
})


export class DateAgoPipe implements PipeTransform {

  private cachedData: any = null;
  private cachedUrl = '';
  
  transform(value: any, langCode= 'pt-BR') {
    const url = `../../utils/i18n/locale/date-base/date-base.i18n.${langCode.substring(0, 2)}.json`;
    if (value && url !== this.cachedUrl) {
      this.cachedData = null;
      this.cachedUrl = url;
      
      const localeService = new LocaleServiceController(); 
      localeService
        .getAsyncTranslations('date-base')
        .then((dateBase: any) => {
          const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
          
          if (seconds < 29) {
            this.cachedData = dateBase.dateBaseIntervals.justNow;
            return;
          }
          
          const intervals = {
            [dateBase.dateBaseIntervals.year]: 31536000,
            [dateBase.dateBaseIntervals.month]: 2592000,
            [dateBase.dateBaseIntervals.week]: 604800,
            [dateBase.dateBaseIntervals.day]: 86400,
            [dateBase.dateBaseIntervals.hour]: 3600,
            [dateBase.dateBaseIntervals.minute]: 60,
            [dateBase.dateBaseIntervals.second]: 1
          };
    
          let counter;
          
          
          
          for (const i in intervals) {
            counter = Math.floor(seconds / intervals[i]);
            if (counter > 0) {
              if (counter === 1) {
                this.cachedData = counter + ' ' + i + ' '; // singular (1 day ago)
                return;
              } else {
                if (i === 'mês'){
                  this.cachedData = counter + ' ' + 'meses ';
                  return;
                }
                this.cachedData = counter + ' ' + i + 's '; // plural (2 days ago)
                return;
              }
            }
          }
      });


    }
    
    return this.cachedData;
  }
  
}